module.exports = __webpack_public_path__ + "img/901420133.4e0c1a59.png";